module.exports = __webpack_public_path__ + "files/a7706812af27e24b51b9b27901d53501.png";